/**
 * Set a cookie by name
 */
function setCookie(c_name : string, value : string, exdays : number) : void {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var c_value =
    escape(value) + (exdays == null ? '' : '; expires=' + exdate.toUTCString()) + '; path=/';
  document.cookie = c_name + '=' + c_value;
}

/**
 * gets a cookie by name
 *
 */

function getCookie(c_name : string) : string | null {
  let c_value : string | null = document.cookie;
  let c_start = c_value.indexOf(' ' + c_name + '=');
  if (c_start == -1) {
    c_start = c_value.indexOf(c_name + '=');
  }
  if (c_start == -1) {
    c_value = null;
  } else {
    c_start = c_value.indexOf('=', c_start) + 1;
    var c_end = c_value.indexOf(';', c_start);
    if (c_end == -1) {
      c_end = c_value.length;
    }
    c_value = unescape(c_value.substring(c_start, c_end));
  }
  return c_value;
}

function getCookieInt(name : string) : number | null {
  var v = getCookie(name);
  if (v !== null) {
    return parseInt(v);
  } else {
    return null;
  }
}

function deleteCookie(name : string) {
  var cookieDS = new Date();
  cookieDS.setTime(cookieDS.getTime() - 1);
  document.cookie = name + '=; expires=' + cookieDS.toUTCString();
}

export { setCookie, getCookie, getCookieInt, deleteCookie };
